export type { IMongoDescriptor } from '../database/index.js';
export type { IStorageDescriptor, IS3Descriptor } from '../storage/index.js';

export interface ICloudflareDescriptor {
  authToken: string;
};

export interface ILetterExpressDescriptor {
  email: string,
  apiToken: string,
}
